import {
  NOTIFICATIONS_ADD,
  NOTIFICATIONS_REMOVE,
  NOTIFICATIONS_SET,
  NOTIFICATIONS_SET_EMPTY,
  NOTIFICATIONS_SET_MESSAGE,
  NOTIFICATIONS_SET_TOTAL
} from './types';

export const mutations = {
  [NOTIFICATIONS_ADD]: (state, payload) => {
    state.notifications.push(payload);
  },
  [NOTIFICATIONS_REMOVE]: (state, payload) => {
    state.notifications.splice(state.notifications.map(n => n.id).indexOf(payload), 1);
  },
  [NOTIFICATIONS_SET_MESSAGE]: (state, payload) => {
    state.notification = { timeout: 10000, ...payload };
  },
  [NOTIFICATIONS_SET]: (state, payload) => {
    state.notifications = payload;
  },
  [NOTIFICATIONS_SET_EMPTY]: (state) => {
    state.notifications = [];
  },
  [NOTIFICATIONS_SET_TOTAL]: (state, payload) => {
    state.notificationsTotal += payload;
  }
};
